import { Injectable } from "@angular/core";
import { NgxMaskPipe } from "ngx-mask";

@Injectable({
  providedIn: "root"
})
export class MasquesService {

  placeholderTelephoneCanada = "(xxx) xxx - xxxx";
  masqueTelephoneCanada="(000) 000 - 0000";
  myMaskPipe: NgxMaskPipe;

  constructor(maskPipe: NgxMaskPipe) {
   this.myMaskPipe = maskPipe;
  }

  public getMasqueTelephoneCanada(): string {
    return this.masqueTelephoneCanada;
  }

  public getPlaceholderTelephoneCanada() {
    return this.placeholderTelephoneCanada;
  }

}
